/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__user__model__SortByColumnEnum;

(function (jove__app__user__model__SortByColumnEnum) {
  jove__app__user__model__SortByColumnEnum["EMAIL"] = "email";
  jove__app__user__model__SortByColumnEnum["FIRST_NAME"] = "first_name";
  jove__app__user__model__SortByColumnEnum["LAST_NAME"] = "last_name";
  jove__app__user__model__SortByColumnEnum["UPDATED_AT"] = "updated_at";
  jove__app__user__model__SortByColumnEnum["CREATED_AT"] = "created_at";
})(jove__app__user__model__SortByColumnEnum || (jove__app__user__model__SortByColumnEnum = {}));